import { uniqueId } from 'lodash';
import React from 'react';

/**
 *
 * @param depedencies Generates a new lodash _.uniqueId when any dependencies in dependencies change
 * @returns a lodash uniqueId
 */
export const useUniqueKey = (dependencies?: React.DependencyList): string => {
  const [uniqueKey, setUniqueKey] = React.useState<string>(uniqueId());
  React.useEffect(
    () => {
      setUniqueKey(uniqueId());
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    dependencies ? [...dependencies] : [],
  );
  return uniqueKey;
};
